import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPanel.css';

const AdminPanel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-panel-container">
      <button
        type="button"
        className="admin-panel-card"
        onClick={() => navigate('/admin/general-settings')}
      >
        General Settings
      </button>
      <button
        className="admin-panel-card"
        onClick={() => navigate('/admin/shelf-manage')}
      >
        Create or Delete Shelf Location
      </button>
      <button
        className="admin-panel-card"
        onClick={() => navigate('/admin/bundle-scan-subset')}
      >
        Manage Bundle Parent Scans
      </button>
      <button
        type="button"
        className="admin-panel-card"
        onClick={() => navigate('/admin/bundle-defaults')}
      >
        Manage Bundle Default Components
      </button>
      <button
        type="button"
        className="admin-panel-card"
        onClick={() => navigate('/admin/bundle-thresholds')}
      >
        Manage Bundle Thresholds
      </button>
      <button
        type="button"
        className="admin-panel-card"
        onClick={() => navigate('/admin/recurring-tasks')}
      >
        Recurring task definitions
      </button>
      <button
        type="button"
        className="admin-panel-card"
        onClick={() => navigate('/admin/task-tags')}
      >
        Task tags
      </button>
      <button
        className="admin-panel-card"
        onClick={() => navigate('/admin/dashboard')}
      >
        Dashboard
      </button>
      <button
        className="admin-panel-card"
        onClick={() => navigate('/admin/past-performance')}
      >
        Past Performance
      </button>
    </div>
  );
};

export default AdminPanel;
